import { Badge, Flex, Stack, Text } from '@chakra-ui/react'

import CustomFormEmptyAnswerFeedback from 'components/tools/CustomForm/commonComponents/CustomFormEmptyAnswerFeedback'
import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'

export default function CustomFormSingleSelectionBoxAnswer() {
  const { answer } = useCustomFormAnswer()

  return (
    <CustomFormEmptyAnswerFeedback>
      <Stack spacing={[1, 1, 1, 2, 2, 2]} direction="column" align="flex-start">
        {(answer?.answer || []).map((option: string, index) => {
          const hasScore = answer?.has_score
          const hasAnswer = answer?.answer?.includes(option)
          const answerScoreSettings = answer?.score_settings?.options[index]
          const scoreOptionKeyValue = hasScore ? answerScoreSettings.value : ''
          const answerIsEqualToOption = answer.answer ? answer.answer[0] === option : false

          return (
            <Flex align="center" justify="space-between" key={index} gap={2}>
              <Flex alignItems="center" gap={2}>
                <Text color={'primary'} fontWeight={'medium'}>
                  {option}
                </Text>
              </Flex>

              {hasScore && (
                <Badge colorScheme={hasAnswer && answerIsEqualToOption ? 'green' : 'red'}>
                  Pontuação: {scoreOptionKeyValue}
                </Badge>
              )}
            </Flex>
          )
        })}
      </Stack>
    </CustomFormEmptyAnswerFeedback>
  )
}
